module.exports = __webpack_public_path__ + "static/img/5-z5.6f0f8c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/5-z5.jpg
// module id = 672
// module chunks = 140